import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center bg-subtle px-6 py-16">
      <section className="w-full max-w-xl rounded-lg border border-line bg-card p-10 text-center shadow-sm">
        <p className="font-ui text-sm font-semibold uppercase tracking-[0.12em] text-action">404</p>
        <h1 className="mt-3 font-display text-4xl font-bold text-fg-primary">Page not found</h1>
        <p className="mt-4 font-body text-lg text-fg-muted">
          The page you were looking for is not part of FMC Events.
        </p>
        <Link
          className="mt-8 inline-flex rounded-sm bg-action px-6 py-3 font-ui text-sm font-semibold text-action-foreground hover:bg-action-hover"
          to="/"
        >
          View all events
        </Link>
      </section>
    </main>
  );
}
